var map = {
	"./auth.js": "9OW0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wDUe";


//////////////////
// WEBPACK FOOTER
// ./src/stores nonrecursive [\w-]\.js$
// module id = wDUe
// module chunks = 1